import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Divider,
  ListItem,
  Typography
} from "@material-ui/core";
import { ChevronRight } from '@material-ui/icons';

import styles from "./styles";
import useGlobalContext from "../../../common/hooks/useGlobalContext";
import capitalizeFirstChar from "../../../common/utils/capitalizeFirstChar" 

const UserInfoCard = props => {
  const {
    classes,
    isCarsharing,
    setRightSidePanelOpen,
    user
  } = props
  const {
    business_admin,
    business_entity,
    business_entities,
    id,
    user: userObj,
    user_profile
  } = user
  const { setProfileFormPanel } = useGlobalContext();
  const businessEntity = business_entity || business_entities
  const formInfo = isCarsharing ? user : { ...userObj, id, user_profile}

  const setProfileServiceType = () => {
    if (isCarsharing) {
      setRightSidePanelOpen(true)
      return setProfileFormPanel("user", formInfo)
    }

    if (business_admin) {
      return setProfileFormPanel("admin", formInfo)
    } 

    return setProfileFormPanel("rider", formInfo)
  }  

 const descriptor = isCarsharing ? capitalizeFirstChar(formInfo.status) : businessEntity && businessEntity[0].legal_name
 const userFullName = `${formInfo.first_name}  ${formInfo.last_name}`

  return (
    <React.Fragment>
      <ListItem
        button
        className={classes.listItem}
        onClick={setProfileServiceType}
      >
        <Avatar
          alt={userFullName}
          className={classes.avatar}
        />
        <div>
          <Typography>{userFullName}</Typography>
          <Typography className={classes.listItemSubtext} variant="body2">
            {descriptor}
          </Typography>
        </div>
        <ChevronRight className={classes.iconRight} />
      </ListItem>
      <Divider variant="inset" />
    </React.Fragment>
  );
};

export default withStyles(styles)(UserInfoCard);
